export function TagPlusIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path fill="currentColor" d="M9 11a2 2 0 100-4 2 2 0 000 4z"></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M19.88 9.823c.879.704 1.25 1.79 1.09 2.813a6 6 0 01-8.333 8.333 2.996 2.996 0 01-2.814-1.09l-6.166-7.707A3 3 0 013 10.298v-2.47a3 3 0 01.879-2.12l1.828-1.83A3 3 0 017.828 3h2.47a3 3 0 011.874.657l7.708 6.166zM7.12 5.293A1 1 0 017.828 5h2.47a1 1 0 01.625.22l6.08 4.864a6 6 0 00-6.92 6.92l-4.864-6.08A1 1 0 015 10.297v-2.47a1 1 0 01.293-.707L7.12 5.293zM16 12a1 1 0 011 1v2h2a1 1 0 110 2h-2v2a1 1 0 11-2 0v-2h-2a1 1 0 110-2h2v-2a1 1 0 011-1z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
